import React from "react";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Client from "./Pages/Client";
import Service from "./Pages/Service";
import Contact from "./Pages/Contact";
import './styles/style.css' ;
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';


function App() {
  return (
    <>
    <Router>
    <Routes>
    <Route  path='/' element={<Home />} />
    <Route  path="/about" element={<About/>} />
    <Route  path="/service" element={<Service/>} />
    <Route path="/client" element={<Client/>} />
    <Route path="/contact" element={<Contact/>} />
    </Routes>
    </Router>
    </>
  );
}

export default App;
